/// <reference path="../../../../node_modules/@types/datatables.net/index.d.ts" />
/// <reference path="../../../../node_modules/@types/jquery/index.d.ts" />

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { User } from '../models/user.model';
import { UserService } from '../services/user.service';
import { Alert, AlertType } from '../../shared/alert.model';
import { getAlertMessage } from '../../shared/api-loaders';
import { ResourcePermissions } from '../../shared/resource-permissions.model';
import { Subscription } from 'rxjs';
import { MessageService } from '../../shared/message.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../shared/modal.service';
import { MessageType } from '../../shared/messageType';
import { PaginationService } from '../services/pagination.service';
import { Router } from '@angular/router';
import { UserStatusValues } from '../models/userStatusValues';
import { fromEvent } from 'rxjs';
import { filter, debounceTime } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TransactionLogService } from '../services/transaction-log.service';
import { Select2Option } from '../../shared/select2-option';
import { SecurityService } from '../../shared/security.service';
import { ConfigurationService } from '../../ect-feature/services/configuration.service';
import { UserDetailService } from '../services/user-detail.service';
import { UserDetailOptionsFacility } from '../models/user-detail-options';

@Component({
    template: `
    <div class="modal-header">
      <h4 *ngIf="userAction == 'Activate'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Activate User</h4>
      <h4 *ngIf="userAction == 'Deactivate'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Deactivate User</h4>
      <h4 *ngIf="userAction == 'Suspend'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Suspend User</h4>
      <h4 *ngIf="userAction == 'Delete'" class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Delete User</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="(userAction == 'Activate') && user.deactivationDate">
        <h6>Are you sure you want to reactivate {{user.firstName}} {{user.lastName}}?</h6>
        <p>This will remove deactivation date {{ user.deactivationDate }} for the user </p>
        <p>Once reactivated, you can change the deactivation date for the user later.</p>
      </div>
      <div *ngIf="userAction == 'Deactivate'">
        <h6>Are you sure you want to deactivate {{user.firstName}} {{user.lastName}}?</h6>
        <p>This will remove access rights and permissions for the user to all applications.</p>
        <p>Once deactivated, you can activate or delete the user later.</p>
      </div>
      <div *ngIf="userAction == 'Suspend'">
        <h6>Are you sure you want to suspend {{user.firstName}} {{user.lastName}}?</h6>
        <p>This will temporarily restrict users access to their applications.</p>
        <p>Once suspended you can activate the user later.</p>
      </div>
      <div *ngIf="userAction == 'Delete'">
        <h6>Are you sure you want to delete {{user.firstName}} {{user.lastName}}?</h6>
        <p>This will permanently delete the user, this action cannot be undone.</p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" [re-disable-when-clicked] [ngClass]="userAction == 'Activate' ? 'btn btn-primary' : 'btn btn-danger'" (click)="submitModal(userAction)">{{userAction}}</button>
      <button type="button" class="btn btn-cancel" (click)="activeModal.close('Cancel click')">Cancel</button>
    </div>
  `,
    standalone: false
})
export class UserListActionsModalComponent {
  @Input() user: User;
  @Input() userAction: string;
  @Output() userDetailActionsEvent: EventEmitter<string> = new EventEmitter()
  constructor(public activeModal: NgbActiveModal) { }

  submitModal(action: string) {
    this.userDetailActionsEvent.emit(action);
  }
}


@Component({
    selector: 're-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    standalone: false
})
export class UserListComponent implements OnInit, OnDestroy, AfterViewInit {

  permissions: ResourcePermissions;
  loading: boolean;
  alert: Alert;
  searchText: string;
  allowSearch: boolean;
  showMessage = false;
  ssoId: string;
  user: User;
  modalReference: any;
  // hasGlobalError = false;
  messageSubscription: Subscription;
  isAuthenticated: boolean;
  userAction: string;
  userFirstName: string;
  userLastName: string;

  selectedStatusFilter = ' ';

  isLocationAdmin = false;
  isLocationLimitedAdmin = false;
  isCorporateAdmin = false;
  isCorporateLimitedAdmin = false;
  isPhysicianFeatureEnabled = false;
  selectedUserType = 'non-physician';
  userTypeOptions: Select2Option[] = [
    { id: 'non-physician', text: 'Non-Provider Users' },
    { id: 'physician', text: 'Physician/NPPA' },
  ];
  locationOptions: Select2Option[] = [];
  selectedLocation: string = '';
  selectedLocationName: string = '';

  private nonSearchableChars = /[*\\]/;
  mcNextLink: string;
  statusDropdownOptions: Select2Option[];// = this.statusFilterOptions.map(x => { return { id: x, text: x } });



  // pagination object
  pagination: any = {};
  // User list items after pagination
  pagedItems: any[];
  entriesPerPage = 25;
  dataTable: DataTables.Api;
    searchSubscription: Subscription;

  constructor(
    public userService: UserService,
    private messageService: MessageService,
    private modalService: ModalService,
    private paginationService: PaginationService,
    private router: Router,
    private ngZone: NgZone,
    private transactionLogService: TransactionLogService,
    private securityService: SecurityService,
    private configurationService: ConfigurationService,
    private userDetailService: UserDetailService
  ) {


    this.searchText = '';
    this.allowSearch = true;

    this.messageSubscription = this.messageService.get().subscribe(message => {
      // TODO: Refactor this with a better approach.
      if (message == MessageType.UserCreated || message == MessageType.UserDeleted) {
        this.showMessage = message // Expected actions ('CREATED' || 'Delete');
        this.userAction = message;
        this.clearAlerts();
      }
    })



  }

  ngAfterViewInit(): void {
    let searchInput = this.searchbox.nativeElement as HTMLInputElement;
    this.searchSubscription = fromEvent(searchInput, "input")
      .pipe(
        debounceTime(500),
        filter(v => this.searchText.length >= 3 || this.searchText.length==0)
      ).subscribe(x => {
        this.searchUsers();
    })
  }

  ngOnDestroy(): void {
    delete window[ "currentComponent" ];
    if (this.dataTable)
      this.dataTable.destroy();

    this.searchSubscription.unsubscribe();
  }



  navigateToRoute(url: string) {

    this.ngZone.run(() => {
      this.router.navigateByUrl(url);
    })
  }

  private serialize(obj: any) {

    return encodeURIComponent(JSON.stringify(obj));
  }

  private deserialize(text: string): any {
    return JSON.parse(decodeURIComponent(text));

  }
  errorCount: number = null;
  refreshErrorCount() {
    this.transactionLogService.getErrorCount().subscribe(x => {
      this.errorCount = x;
    });
  }
  //showErrorCountAlert = true;
  async ngOnInit() {
    this.isLocationAdmin = await this.securityService.isUserManagementLocalAdmin().toPromise();
    this.isLocationLimitedAdmin = await this.securityService.isUserLocationLimitedAdmin().toPromise();
    this.isCorporateAdmin = await this.securityService.isUserManagementCorporateAdmin().toPromise();
    this.isCorporateLimitedAdmin = await this.securityService.isCorporateLimitedAdmin().toPromise();

    if (this.isLocationAdmin || this.isLocationLimitedAdmin || this.isCorporateAdmin || this.isCorporateLimitedAdmin) {
      const options = await this.userDetailService.getOptions().toPromise();
      const configId = options?.[0]?.configId;
      if (configId) {
        this.configurationService.isPhysicianFeatureEnabled(configId).subscribe(enabled => {
          this.isPhysicianFeatureEnabled = enabled;
        });
      }

      // Populate location options for LLA users
      if (this.isLocationLimitedAdmin) {
        let facilities = new Array<UserDetailOptionsFacility>();
        options
          .map((x) => x.facilities)
          .forEach((corpFacilities) => {
            corpFacilities.forEach((facility) => {
              facilities.push(facility);
            });
          });
        this.locationOptions = facilities.map<Select2Option>((x) => ({
          id: x.name,
          text: x.name,
        }));
        if (this.locationOptions.length > 0) {
          this.selectedLocation = this.locationOptions[0].id;
          this.selectedLocationName = this.locationOptions[0].text;
        }
      }
    }

    this.refreshErrorCount();
    this.userService.getStatus().subscribe(x => {
      var r = x.map(x => { return { id: x.userStatusId, text: x.name } });

      r.unshift({ id: ' ', text: 'All' });

      this.statusDropdownOptions = r;
    }, error => {
      this.alert = getAlertMessage(error);
      this.loading = false;
    })

    window[ "currentComponent" ] = this;

    this.dataTable = $('#userList').DataTable({
      responsive: false,
      ordering: true,
      searching: false,
      paging: true,
      info: true,
      serverSide: true,
      pagingType: 'full_numbers',
      processing: false,
      pageLength: this.entriesPerPage,
      //order:[["firstName", "asc"]],
      dom:
        '<"row"<"col-sm-12"f>>' +
        '<"row"<"col-sm-12"tr>>' +
        '<"row d-none d-sm-flex"<"col-sm-12"<"float-right"p><"float-right neo-dt-l"l>>>' +
        '<"row d-flex d-sm-none"<"col-sm-6"l><"col-sm-6"p>>' +
        '<"row float-right d-none d-sm-flex"<"col-sm-12"<"float-right neo-dt-i"i>>>' +
        '<"row d-flex d-sm-none"<"col-sm-12"i>>',
      ajax: (data, callback, settings) => this.ajaxCallback(data, callback, settings),
      language: {
        emptyTable: 'No Matching Records Found.',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>'
        },

      },
      columns: [
        {
          className: '', data: 'firstName', title: 'First Name', render: (data: any, type: any, u: User) => {
            return `<a href='javascript:currentComponent.navigateToRoute("/user/${u.ssoid}")'><img style='display:${u.federatedIdentity ? '' : 'none'}' class='pr-2' data-toggle="tooltip" data-placement="right" title='Federated User' src='assets/images/Federated User Icon.svg'>${u.firstName}</a>`;
          }
        },
        {
          title: 'Last Name', data: 'lastName', render: (data: any, type: any, u: User) => {
            return `<a href='javascript:currentComponent.navigateToRoute("/user/${u.ssoid}")'>${u.lastName}</a>`;
          }
        },
        { data: 'userName', title: 'Username' },
        {
          data: 'email', title: 'E-mail', render: (data: any, type: any, u: User) => {
            return `${this.userService.isDummyEmail(u.email) ? '' : u.email}`;
          }
        },
        {
          data: 'userAccessType', title: 'IDM User Admin Access', render: (data: any, type: any, u: User) => {
            return `${this.userService.getUserAccesText(u.userAccessType)}`;
          }
        },
        {
          data:'UserStatusName', title: 'Status', render: (data: any, type: any, u: User) => {
            let statusBadge = this.getStatusBadge(u);
            let html = ``;
            if (statusBadge) {
              html += `<span class="${statusBadge}"><span class="m-lg-2">${u.status==null?"":u.status}</span></span>`;
            }
            else {
              html += (u.status == null ? "" : u.status);
            }

            return html;
          }
        },
        {
          orderable: false, title: 'Actions', className: 'actionsCell', render: (data: any, type: any, u: User) => {
            if (!u.userStatusId) {
              return '';
            }

            let html = `<span class="dropdown">
  <button class="btn btn-link dropdown-toggle p-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Actions
  </button>

  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">`;




            let serializedUser = this.serialize(u);

            if (u.userStatusId == UserStatusValues.LockedOut) {
              html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.unlock(currentComponent.deserialize('${serializedUser}'))">Unlock</a>`;
            }
            if (u.userStatusId != UserStatusValues.Suspended && u.userStatusId != UserStatusValues.Deactivated) {
              html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.open('Suspend', currentComponent.deserialize('${serializedUser}') )">Suspend</a>`;
            }
            if (u.userStatusId == UserStatusValues.Deactivated || u.userStatusId == UserStatusValues.Suspended || u.userStatusId == UserStatusValues.Staged) {
              html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.activate(currentComponent.deserialize('${serializedUser}'),'${u.status}')">Activate</a>`;
            }
            if (u.userStatusId != UserStatusValues.Deactivated && this.selectedUserType != 'physician') {
              html += `<a href="javascript:" class="dropdown-item"  onclick="currentComponent.open( 'Deactivate', currentComponent.deserialize('${serializedUser}'))">Deactivate</a>`;
            }
            if (u.userStatusId === UserStatusValues.Deactivated) {
              html += `<a href="javascript:" class="dropdown-item" onclick="currentComponent.open( 'Delete', currentComponent.deserialize('${serializedUser}') )">Delete</a>`;
            }

            html += '</div></span>'
            return html;
          }
        },

      ]

    });
    this.dataTable.on("draw", () => {
      $('[data-toggle="tooltip"]')[ "tooltip" ]();
      $('[data-toggle="tooltip"]').on("click", function (){
        $(this)[ "tooltip" ]('hide');
      });
      this.dataTable[ "responsive" ].rebuild();
      this.dataTable[ "responsive" ].recalc();
      $('.dropdown-toggle')[ "dropdown" ]();
      this.loading = false;
    })

    new $.fn.dataTable[ "FixedHeader" ](this.dataTable);


  }

  getStatusBadge(u: User): string {
    if (u.userStatusId === UserStatusValues.Suspended)
      return 'badge badge-default';

    if (u.userStatusId === UserStatusValues.Deactivated)
      return 'badge badge-default';

    if (u.userStatusId === UserStatusValues.PasswordExpired)
      return 'badge badge-danger';

    return '';
  }
  ajaxCallback(data: any, callback: (data: any) => void, settings: DataTables.SettingsLegacy): void {
    this.loading = true;

    var columnNumbers = data.order.map(x => x.column);
    var columnNames = [];
    var sortDirections = []

    for (var i = 0; i < columnNumbers.length; i++) {
      columnNames.push(data.columns[ columnNumbers[ i ] ].data);
      sortDirections.push(data.order[ i ].dir);
    }
    let status = this.selectedStatusFilter;



    this.userService.getPage(this.searchText, columnNames.join(","), sortDirections.join(","), data.start / data.length, data.length, status, this.selectedUserType === 'physician', this.isLocationLimitedAdmin ? this.selectedLocationName : '')
      .subscribe(x => {
        this.loading = false;
        callback(x);
      }, error => {
        // console.log("error while suspending an user");
        this.loading = false;
        this.alert = getAlertMessage(error);
      });

  }


  clearAlerts() {
    this.alert = null;
    setTimeout(() => this.showMessage = false, 5000);
  }

  listUsersByStatusFilter(statusFilter: Select2Option) {
    this.selectedStatusFilter = statusFilter.id;
    //this.getUsers();
  }

  searchUsers() {

    if (this.allowSearch) {
      this.getUsers();
    }
  }

  clearSearch() {
    this.searchText = '';
    this.allowSearch = true;
    this.selectedStatusFilter = ' ';
    this.selectedUserType = 'non-physician';
    //this.getUsers();
  }

  onUserTypeChanged($event): void {
    this.selectedUserType = $event.id;
    this.getUsers();
  }

  selectedLocationChanged($event): void {
    this.selectedLocationName = this.locationOptions.find(
      (x) => x.id === $event.id,
    )?.text || '';
    this.selectedLocation = $event.id;
    this.getUsers();
  }

@ViewChild("searchbox")
  searchbox: ElementRef;

  allowSearchText(searchText: string) {
    return this.nonSearchableChars.test(searchText);
  }

  validateSearchText() {
    this.allowSearch = !this.nonSearchableChars.test(this.searchText);
    return this.allowSearch;
  }

  searchInputKeyPress(event: any) {
    const inputChar = String.fromCharCode(event.charCode);

    if (this.nonSearchableChars.test(inputChar)) {
      this.allowSearch = false;
    } else {
      this.validateSearchText();
    }
  }


  open(action, user) {
    this.user = user;
    this.userAction = action;
    this.modalService.openModal(UserListActionsModalComponent);
    this.modalReference = this.modalService.modalRef;
    const component = <UserListActionsModalComponent>this.modalReference.componentInstance;
    component.user = this.user;
    component.userAction = this.userAction;
    component.userDetailActionsEvent.subscribe(($action) => {
      this.modalSubmit($action);
    })
  }

  modalSubmit(action) {
    if (action === 'Suspend') {
      this.suspend(this.user);
    } else if (action === 'Deactivate') {
      this.deactivate(this.user);
    } else if (action === 'Delete') {
      this.delete(this.user);
    } else if (action === 'Activate') {
      this.activate(this.user, this.user.status);
    }
  }
  updateScreenDelay = 1000;
  suspend(user): void {
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.userService
      .suspend(this.user.ssoid)
      .subscribe(
        res => {
          this.modalReference.close();
          this.showMessage = true;
          this.clearAlerts();

            this.getUsers();
        },
        error => {
          // console.log("error while suspending an user");
          this.alert = getAlertMessage(error);
          this.modalReference.close();
        });
  }

  deactivate(user): void {
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.userService
      .deactivate(this.user.ssoid)
      .subscribe(
        res => {
          this.modalReference.close();
          this.showMessage = true;
          this.clearAlerts();
          //TODO: lets remove this condition in future releases
            this.getUsers();

        },
        error => {
          // console.log("error while inactivating an user");
          this.alert = getAlertMessage(error);
          this.modalReference.close();
        });
  }

  delete(user): void {
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.userService
      .delete(this.user.ssoid)
      .subscribe(
        res => {

          this.modalReference.close();
          this.showMessage = true;
          this.clearAlerts();
            this.getUsers();
        },
        error => {
          // console.log("error while deleting an user");
          this.alert = getAlertMessage(error);
          this.modalReference.close();
        });
  }

  unlock(user): void {
    this.userAction = 'Unlock';
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.userService
      .unlock(this.user.ssoid)
      .subscribe(
        res => {
          this.showMessage = true;
          this.clearAlerts();
            this.getUsers();
        },
        error => {
          // console.log("error while unlocking an user");
          this.alert = getAlertMessage(error);
        });
  }


  activate(user, status:string): void {
    this.userAction = 'Activate';
    this.user = user;
    this.userFirstName = this.user.firstName;
    this.userLastName = this.user.lastName;
    this.userService
      .activate(this.user, status)
      .then(
        res => {

          if (res != null) {
            this.showMessage = true;
            this.clearAlerts();
              this.getUsers();
          }
        },
        error => {
          // console.log("error while activating an user");
          this.alert = getAlertMessage(error);
        });
  }


  /**
   * Get users with start index and page size.
   */
  getUsers(): void {
    this.showMessage = false;
    this.dataTable.search("").draw(); //the search text will be used dataTableBeforeSend
    // with params


  }




}
